module.exports = __webpack_public_path__ + "img/4-3.e4c21cf.png";